import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { useI18n } from 'i18n';
import { IMonitoringAssetForm } from 'types/vehicles-monitoring';
import { SelectPicker } from 'components/molecules/select-picker';
import { devicesStateSelector } from 'core/redux/selectors/devices';

import styles from './styles.module.css';

interface ITrackerFieldProps {
  isLoading: boolean;
}

export const TrackerField: FC<ITrackerFieldProps> = ({ isLoading }) => {
  const { fc } = useI18n();

  const { control, formState } = useFormContext<IMonitoringAssetForm>();

  const devices = useSelector(devicesStateSelector).list;

  const options = useMemo(() => devices?.map(({ name, uri }) => ({ value: uri, label: name || uri })) || null, [
    devices,
  ]);

  const error = formState.errors.tracker?.message;

  return (
    <Controller
      control={control}
      name="tracker"
      rules={{ required: fc('please select tracker') }}
      render={({ value, onChange }) => (
        <div className={styles.select}>
          <SelectPicker
            error={error}
            readOnly={isLoading}
            selected={value}
            onChange={onChange}
            options={options}
            withSearch
            required
          />
        </div>
      )}
    />
  );
};
